import { format } from 'date-fns';
import { isUrl, removeTrailingSlash } from '../utils/url';
import { getConfig } from '../configuration';
import formatInternalLog from '../utils/format';
export const check = () => {
  const iotUrl = getConfig('iotBaseUrl');
  let configIsOk = true;
  if (!iotUrl || !removeTrailingSlash(iotUrl)) {
    console.error(formatInternalLog('Cannot log to IOT platform as the iotBaseUrl is not defined'));
    configIsOk = false;
  } else if (!isUrl(removeTrailingSlash(iotUrl))) {
    console.error(formatInternalLog('Cannot log to IOT platform as the iotBaseUrl is not a valid url'));
    configIsOk = false;
  }
  return configIsOk;
};
const pushToIot = (message, data, level = 'INFO') => {
  const appName = getConfig('appName');
  const version = getConfig('version');
  const iotUrl = getConfig('iotBaseUrl');
  const additionalData = {
    ...data
  };
  const logWs = `${removeTrailingSlash(iotUrl)}/braincube/apps/log`;
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  fetch(`${logWs}`, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({
      app: appName,
      version,
      messages: [{
        date: format(new Date(), 'yyyyMMdd_HHmmssSSS xxx'),
        level,
        msg: message,
        type: '',
        data: additionalData
      }]
    })
  }).catch(error => {
    console.error(formatInternalLog('Fetching log failed'), error);
  });
};
const logger = {
  key: 'iot',
  check,
  init: () => {},
  handle: (level, message, data) => {
    switch (level) {
      case 'debug':
        pushToIot(message, data, 'DEBUG');
        break;
      case 'info':
        pushToIot(message, data);
        break;
      case 'warn':
        pushToIot(message, data, 'WARNING');
        break;
      case 'error':
        pushToIot(message, data, 'SEVERE');
        break;
      default:
        console.error(formatInternalLog(`Unknown or logging not available for the level ${level}`));
    }
  }
};
export default logger;